import { render, staticRenderFns } from "./zen_no_search_bar.vue?vue&type=template&id=c2c156d6&scoped=true&"
import script from "./zen_no_search_bar.vue?vue&type=script&lang=js&"
export * from "./zen_no_search_bar.vue?vue&type=script&lang=js&"
import style0 from "./zen_no_search_bar.vue?vue&type=style&index=0&id=c2c156d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c156d6",
  null
  
)

export default component.exports